import { useRecoilValue } from 'recoil';
import { TProjectConfigurationGeneralItem } from 'pages/common/types';
import { getComplementaryProductsTotalPrice } from '../helpers/get-complementary-products-total-price';
import { savedConfigurationCalculationState } from '../store/calculation';
import { ZERO_PRICE } from '../consts/prices';

export const useTotalPrices = () => {
  const calculationFormState = useRecoilValue(savedConfigurationCalculationState);
  const { mainProduct, complementaryProducts, checkedProducts, complimentaryGroups } = calculationFormState;
  const { price, quantity } = mainProduct as TProjectConfigurationGeneralItem;
  const mainProductTotalPrice = price ? price * quantity : ZERO_PRICE;
  const isShowComplementaryProductsTotalPrice =
    complementaryProducts.length + complimentaryGroups.length !== 0;
  const complementaryProductsTotalPrice = isShowComplementaryProductsTotalPrice
    ? getComplementaryProductsTotalPrice({ complementaryProducts, checkedProducts, complimentaryGroups })
    : ZERO_PRICE;
  const totalPrice = mainProductTotalPrice + complementaryProductsTotalPrice;

  return {
    mainProductTotalPrice,
    complementaryProductsTotalPrice,
    totalPrice,
    isShowComplementaryProductsTotalPrice,
  };
};
